import { GbpToTargetCurrency } from 'types/commonTypes';
import { DATA_REFS, Product } from 'types/productType';
import { DEFAULT_LATEST_DEAL_DATE } from 'views/Portfolio/helpers';

type ObjectType = Record<string, unknown | string>;

export const formatToObject = (columns: string[], rows: string[][]) => {
  const object: ObjectType[] = [];
  rows.forEach((row, rowIndex) => {
    let detailsObject: ObjectType = {};
    columns.forEach((column, columnIndex) => {
      detailsObject = { ...detailsObject, [column]: row[columnIndex], id: rowIndex + 1, rowIndex: rowIndex + 1 };
    });
    object.push(detailsObject);
  });

  return object;
};

const formatProduct = (product: Product, gbpToTargetCurrency: GbpToTargetCurrency): Product => {
  let modifiedProduct: Product = { ...product };
  if (product?.highestBid?.price) {
    modifiedProduct = {
      ...modifiedProduct,
      highestBid: {
        ...product.highestBid,
        priceInTargetCurrency: gbpToTargetCurrency.convert(product.highestBid?.price ?? 0),
        priceGbp: product.highestBid.price,
      },
    };
  }

  if (product?.lowestOffer?.price) {
    modifiedProduct = {
      ...modifiedProduct,
      lowestOffer: {
        ...product.lowestOffer,
        priceInTargetCurrency: gbpToTargetCurrency.convert(product.lowestOffer?.price ?? 0),
        priceGbp: product.lowestOffer.price,
      },
    };
  }

  return {
    ...modifiedProduct,
    latestDealDate: product.latestDealDate ? new Date(product.latestDealDate) : DEFAULT_LATEST_DEAL_DATE,
    highestBidPrice:
      modifiedProduct?.physicalQuantity && modifiedProduct.physicalQuantity > 0
        ? modifiedProduct?.highestBid?.priceInTargetCurrency ?? 0
        : null,
    lowestOfferPrice: modifiedProduct?.lowestOffer?.priceInTargetCurrency ?? 0,
    [DATA_REFS.SANITIZED_WINE_NAME]: product[DATA_REFS.NAME].normalize('NFD').replace(/[\u0300-\u036f]/g, ''),
  };
};
